<template>
	<div class="loader-sm">
		<div class="inner"></div>
	</div>
</template>

<script>
export default {
	props: {},
	data () {
		return {};
	}
};
</script>
<style lang="scss" scoped>
.loader-sm {
	width: 30px;
	height: 30px;
	border: 3px solid $dodger-blue;
	border-bottom: 3px solid transparent;
	border-radius: 50%;
	position: absolute;
    left: -50px;
    bottom: 7px;
	animation: spin 1s linear infinite;
	display: flex;
	justify-content: center;
	align-items: center;

	@include mq(550px) {
		left: 50%;
		transform: translateX(-50%);
		bottom: -26px;
		width: 20px;
		height: 20px;
	}

	&::before, &::after {
		display: none;
	}

	.inner {
		width: 15px;
		height: 15px;
		border: 3px solid transparent;
		border-top: 3px solid $dodger-blue;
		border-radius: 50%;
		animation: spinInner 1s linear infinite;

		@include mq(550px) {
			width: 10px;
			height: 10px;
		}
	}
}
</style>
